import { Fragment, useState } from 'react'
import { useUser } from '../../providers/UserProvider'
import Cta from '../../components/Cta'

function HeroBanner() {
  const [ user, userDispatch ] = useUser();
  let loggedIn = user.loggedIn;

  return(
    <>
    <div className="flex items-center mx-auto max-w-[1440px] xl:h-marketplace-hero bg-none xl:bg-cover xl:bg-hero-marketplace">
      <div className="relative mx-auto text-center rounded-lg xl:w-8/12">
        <h2 className="font-marketplace-hero text-headline-2 lg:text-headline-2-md xl:text-headline-2-lg text-black xl:text-white">
          <span className="block">The Savings Marketplace</span>
        </h2>
        <p className="font-primary mt-4 mx-4 text-body-1 lg:text-body-1-md xl:text-body-1-lg leading-6 text-black xl:text-white">
          Members of The Convoy get access to thousands of dollars in savings on business tools and services of all kinds.
        </p>
      </div>
    </div>
    {/*
    <div className="block lg:hidden mx-auto mb-16 sm:px-6 lg:px-container">
      <div className="relative bg-white mx-auto text-center px-6 rounded-lg">
        <h2 className="text-marketplace-hero-mobile font-marketplace-hero text-black">
          <span className="block">The Savings Marketplace</span>
        </h2>
        <p className="mt-4 mb-6 text-marketplace-subtitle-mobile leading-6 text-black">
          Members of The Convoy get access to thousands of dollars in savings on business tools and services of all kinds.
        </p>
      </div>
    </div>
    */}
    </>
  );
}

export default HeroBanner;
